module.exports = __webpack_public_path__ + "img/kommune-538.0a804ccb.svg";